<div class="date-card">
  <div class="date-input-group">
    <label class="input-label">{{ 'web.purchaseStartDate' | translate }}</label>
    <mat-form-field appearance="outline" class="custom-date-field">
      <input matInput
             [matDatepicker]="picker"
             [(ngModel)]="startDateObj"
             (dateChange)="onStartDateChange()"
             [min]="minDateObj"
             [max]="maxDateObj"
             [matDatepickerFilter]="weekdayFilter"
             (click)="picker.open()"
             (keydown.enter)="picker.open()"
             [attr.aria-label]="'web.purchaseStartDate' | translate"
             [placeholder]="'web.selectStartDate' | translate"
             readonly />
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker [startAt]="minDateObj"></mat-datepicker>
    </mat-form-field>
  </div>

  @if (showTimeInput) {
  <div class="date-input-group">
    <label class="input-label">
      {{ 'web.purchaseValidityTime' | translate }}
    </label>
    <mat-form-field appearance="outline" class="custom-date-field" (click)="!isTimeFixed && timepicker.open()">
        <input matInput 
               class="date-input"
               [value]="displayTimeRange"
               [attr.aria-label]="'web.purchaseValidityTime' | translate"
               readonly
               [disabled]="isTimeFixed"
               [style.cursor]="isTimeFixed ? 'not-allowed' : 'pointer'"
               [placeholder]="'web.selectValidTime' | translate"
               (keydown.enter)="!isTimeFixed && timepicker.open()" />
      <input matInput
             [matTimepicker]="timepicker"
             [(ngModel)]="startTimeObj"
             style="display: none;"
             [disabled]="isTimeFixed"
             [matTimepickerMin]="minTimeObj" />
      @if (!isTimeFixed) {
      <mat-timepicker-toggle matIconSuffix [for]="timepicker"></mat-timepicker-toggle>
      }
      <mat-timepicker #timepicker mode="24h" [interval]="'1m'" (opened)="onTimepickerOpened()" (selected)="onTimeChange($event)"></mat-timepicker>
    </mat-form-field>
  </div>
  }

  @if (!showTimeInput) {
  <div class="date-input-group">
    <label class="input-label">
      {{ 'web.purchaseEndDate' | translate }}
    </label>
    <input type="text"
           class="date-input disabled-input"
           [value]="validToDate"
           [attr.aria-label]="'web.purchaseEndDate' | translate"
           disabled />
  </div>
  }
</div>
